import * as React from 'react';
import Prices from "./Prices";

export default function NormalPrices() {
    return (
        <Prices isCountryPrice={false}/>
    );
}
